import TrapDoorDialog from './TrapDoorDialog';

export default TrapDoorDialog;
export { useTrapDoor, TrapDoorProvider } from './TrapDoorDialog';
